import { CourseAppearanceSettingsState } from './state';
import { ReduxAction } from '../actions';

export const INITIAL_STATE: CourseAppearanceSettingsState = {};

export const CourseAppearanceSettings = (
  state: CourseAppearanceSettingsState = INITIAL_STATE,
  action: ReduxAction
): CourseAppearanceSettingsState => {
  switch (action.type) {
    case 'COURSE_APPEARANCE_SETTINGS_SET_PREVIEW': {
      const { settings } = action;

      return {
        ...state,
        ...settings,
      };
    }
    case 'UPDATE_COURSE_THEME_DATA':
    case 'COURSE_APPEARANCE_SETTINGS_CLEAR_PREVIEW': {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
